import {config as nameConfig} from './Name';
import {config as basicNameConfig} from './BasicName';
import {config as engagementsConfig} from './Engagements';
import {config as serviceLineConfig} from './ServiceLine';
import {config as roleConfig} from './Role';
import {config as dashboardConfig} from './Dashboard';
import {config as groupRiskAssessmentConfig} from './GroupRiskAssesment';
import {config as contactListConfig} from './ContactList';
import {config as tagsConfig} from './Tags';
import {config as customConfig} from './Custom';
import {config as isInternalConfig} from './IsInternal';
import {config as entitiesConfig} from './Entities';
import {config as deleteConfig} from './Delete';

import {contactListColumnIds} from '../../../../util/uiconstants';

const getFixedColumns = (labels, {entityId}) => {
	const nameColumn = nameConfig(labels, entityId, true);
	return [nameColumn];
};

const getStandardColumns = (labels, {isInternal, groupRiskAssessmentAccess, customizeColumns}) => {
	const engagementsColumn = engagementsConfig(labels);
	const serviceLineColumn = serviceLineConfig(labels);
	const roleColumn = roleConfig(labels);
	const dashboardColumn = dashboardConfig(labels);
	const groupRiskAssessmentColumn = groupRiskAssessmentConfig(labels);
	const contactListColumn = contactListConfig(labels);
	const tagsColumn = tagsConfig(labels);

	const filterColumnVisibility = ({id}) =>
		customizeColumns.some(({columnId, isChecked}) => id === columnId && isChecked);

	let standardColumns = [
		tagsColumn,
		serviceLineColumn,
		roleColumn,
		engagementsColumn,
		dashboardColumn,
		groupRiskAssessmentColumn,
		contactListColumn
	];
	if (isInternal)
		standardColumns = [
			engagementsColumn,
			serviceLineColumn,
			roleColumn,
			dashboardColumn,
			groupRiskAssessmentColumn,
			contactListColumn,
			tagsColumn
		];
	if (!groupRiskAssessmentAccess)
		standardColumns = standardColumns.filter(({id}) => id !== contactListColumnIds.groupRiskAssessment);

	return customizeColumns ? standardColumns.filter(filterColumnVisibility) : standardColumns;
};

const getCustomColumns = ({customizeColumns}) => {
	let customColumns = [];
	if (customizeColumns)
		customColumns = customizeColumns
			.filter(({isCustom, isChecked}) => isCustom && isChecked)
			.map((col) => customConfig(col));
	return customColumns;
};

export default (labels, config = null) => {
	let contactTable = [];
	let generateMessage = [];
	const removeContacts = [
		basicNameConfig(labels),
		isInternalConfig(labels),
		entitiesConfig(labels),
		roleConfig(labels)
	];
	if (config) {
		const {
			entityId = null,
			isInternal = null,
			customizeColumns = null,
			groupRiskAssessmentAccess = null,
			handleDelete = null
		} = config;

		let fixedColumns = [],
			standardColumns = [],
			customColumns = [];
		if (entityId) fixedColumns = getFixedColumns(labels, {entityId});
		if (customizeColumns) {
			if (isInternal !== null && groupRiskAssessmentAccess !== null)
				standardColumns = getStandardColumns(labels, {isInternal, groupRiskAssessmentAccess, customizeColumns});

			customColumns = getCustomColumns({customizeColumns});
		}
		contactTable = [...fixedColumns, ...standardColumns, ...customColumns];

		if (handleDelete) {
			generateMessage = [...removeContacts, deleteConfig(handleDelete)];
		}
	}

	return {contactTable, generateMessage, removeContacts};
};
